
import './App.css';
import Header from './components/Header/Header';
import femaleCricketTeam from './fakeData/fakeData';
import 'bootstrap/dist/css/bootstrap.min.css';
import Dashboard from './components/Dashboard/Dashboard';

function App() {
  console.log(femaleCricketTeam)
  return (
    <div>
      <Header></Header>
      <Dashboard></Dashboard>
    </div>
  );
}

export default App;
